import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';

import {
  Card,
  CardContent
} from '@mui/material';

import PatientHeader from '../../../../Common/components/Patients/PatientHeader';
import PatientTable from '../../../../Common/components/Patients/PatientTable';
import RecapPopover from '../../../../Common/components/Patients/RecapPopover';

import { patientRows } from './data';

import {
  detailsCardContentSx,
  detailsCardSx
} from '../../../../Common/components/Styles/InputStyles';

const Details = ({ className, ...rest }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [clinic, setClinic] = useState('clinic');
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const hideClinic = true;

  const filteredRows = useMemo(() => {
    const searchValue = search.trim().toLowerCase();

    if (!searchValue) {
      return patientRows;
    }

    return patientRows.filter(row =>
      row.pname.toLowerCase().includes(searchValue)
    );
  }, [search]);

  const visibleRows = useMemo(() => {
    const startIndex = page * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;

    return filteredRows.slice(startIndex, endIndex);
  }, [filteredRows, page, rowsPerPage]);

  const handleClinicChange = event => {
    setClinic(event.target.value);
  };

  const handleSearchChange = event => {
    setSearch(event.target.value);
    setPage(0);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = event => {
    setRowsPerPage(Number(event.target.value));
    setPage(0);
  };

  const handleRecapOpen = (event, patient) => {
    setAnchorEl(event.currentTarget);
    setSelectedPatient(patient);
  };

  const handleRecapClose = () => {
    setAnchorEl(null);
    setSelectedPatient(null);
  };

  const recapOpen = Boolean(anchorEl);

  return (
    <Card
      {...rest}
      className={className}
      sx={detailsCardSx}>
      <PatientHeader
        clinic={clinic}
        search={search}
        onClinicChange={handleClinicChange}
        onSearchChange={handleSearchChange}
        hideClinic={hideClinic}
      />

      <CardContent sx={detailsCardContentSx}>
        <PatientTable
          count={filteredRows.length}
          page={page}
          rows={visibleRows}
          rowsPerPage={rowsPerPage}
          onPageChange={handlePageChange}
          onRecapOpen={handleRecapOpen}
          onRowsPerPageChange={handleRowsPerPageChange}
        />
      </CardContent>

      <RecapPopover
        anchorEl={anchorEl}
        open={recapOpen}
        selectedPatient={selectedPatient}
        onClose={handleRecapClose}
      />
    </Card>
  );
};

Details.propTypes = {
  className: PropTypes.string
};

export default Details;